import axios from 'axios';
import axiosRetry from 'axios-retry';

const DEFAULT_RETRIES = 0;

export function initAxiosRetry() {
  axiosRetry(axios, { retries: DEFAULT_RETRIES });
}
